(() => {
  const RATE_BY_FORMAT = [
    { match: '30x45', amount: 9.9 },
    { match: '40x60', amount: 14.9 },
    { match: '50x75', amount: 19.9 },
    { match: '60x90', amount: 19.9 },
    { match: '70x100', amount: 19.9 },
  ];

  const normalizeTitle = (value = '') => String(value).toLowerCase().replaceAll('×', 'x').replace(/\s+/g, '');

  const getRate = (variantTitle) => {
    const title = normalizeTitle(variantTitle);
    return RATE_BY_FORMAT.find(({ match }) => title.includes(match))?.amount ?? null;
  };

  const formatEur = (amount) => {
    const locale = document.documentElement.lang || 'fr-FR';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  };

  const updateShippingRate = (root, variantTitle) => {
    if (!root) return;
    const rateNode = root.querySelector('[data-aam-shipping-rate]');
    if (!rateNode) return;
    const amount = getRate(variantTitle);
    if (amount === null) return;
    rateNode.dataset.rateEur = amount.toFixed(2);
    rateNode.textContent = formatEur(amount);
  };

  const updateFromVariantControl = (control) => {
    if (!control) return;
    const variantSelects = control.closest('variant-selects');
    const sectionId = variantSelects?.dataset?.section;
    if (!sectionId) return;

    const root = document.querySelector(
      '[data-aam-product-cro][data-section-id="' + CSS.escape(sectionId) + '"]'
    );
    updateShippingRate(root, control.value || '');
  };

  const hideEmptyJudgeMeBadges = (scope = document) => {
    scope.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
      const rawCount = badge.getAttribute('data-number-of-reviews');
      if (rawCount === null) return;
      const count = Number.parseInt(rawCount, 10);
      if (Number.isNaN(count) || count > 0) return;

      const block = badge.closest('.shopify-block') || badge.closest('[id^="shopify-block-"]') || badge;
      block.hidden = true;
    });
  };

  const init = () => {
    document.querySelectorAll('[data-aam-product-cro]').forEach((root) => {
      updateShippingRate(root, root.dataset.initialVariantTitle || '');
    });

    hideEmptyJudgeMeBadges();

    if (!window.__aamCroAnchorListener) {
      document.addEventListener('click', (event) => {
        const link = event.target.closest('.aam-cro-reassurance__item[href^="#"], .aam-cro-continue__link[href^="#"]');
        if (!link) return;
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', link.getAttribute('href'));
      });
      window.__aamCroAnchorListener = true;
    }

    if (!window.__aamCroVariantControlListener) {
      document.addEventListener('change', (event) => {
        const control = event.target.closest(
          'variant-selects .product-form__input--pill input[type="radio"], variant-selects select'
        );
        if (control) updateFromVariantControl(control);
      });
      window.__aamCroVariantControlListener = true;
    }

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange &&
      !window.__aamCroVariantSubscription
    ) {
      window.__aamCroVariantSubscription = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = event?.data?.sectionId;
        const variant = event?.data?.variant;
        if (!sectionId || !variant) return;

        document
          .querySelectorAll('[data-aam-product-cro][data-section-id="' + CSS.escape(sectionId) + '"]')
          .forEach((root) => updateShippingRate(root, variant.title || ''));
      });
    }

    const observer = new MutationObserver(() => hideEmptyJudgeMeBadges());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews'],
    });
    window.setTimeout(() => observer.disconnect(), 5000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
